import React, { useEffect, useRef, useState } from "react";
import Switch from "../common/Switch/Switch";
import { ReactComponent as ClockIcon } from "./../../resources/images/icons/clock-icon.svg";
import { ReactComponent as LinkedinIcon } from "./../../resources/images/icons/linkedin-icon.svg";
import { ReactComponent as TwitterIcon } from "./../../resources/images/icons/twitter-icon.svg";
import { ReactComponent as FacebookIcon } from "./../../resources/images/icons/facebook-icon.svg";
import { ReactComponent as FounditIcon } from "./../../resources/images/icons/foundit-icon.svg";
import { ReactComponent as LinkIcon } from "./../../resources/images/icons/link-icon.svg";
import { ReactComponent as EcllipseIcon } from "./../../resources/images/icons/eclipse-icon.svg";
import ExpireJobsModal from "../mjpModals/ExpireJobsModal";
import DeleteJobsModal from "../mjpModals/DeleteJobsModal";
import { JobsDataType } from "../../types/api-response";
import RenewListModal from "../mjpModals/RenewListModal";
import LowInventoryModal from "../mjpModals/LowInventoryModal";
import CopyLinkModal from "../mjpModals/CopyLinkModal";
import { shareJob } from "../../utils/shareJob";
import { SHARE_JOB_TYPES } from "../../constants/tags";
import { PASSIVE_JOB } from "../../constants/Filters";
import { toast } from "react-toastify";
import { domainMap } from "../../utils";
interface AdditionalProps {
  selectedRowData: JobsDataType[] | undefined | null;
  isExpire?: boolean;
  setClickedRow?: Function;
  callbackOnClose?: Function;
}

const AdditionalContent = ({
  selectedRowData,
  isExpire,
  setClickedRow = () => {},
  callbackOnClose = () => {},
}: AdditionalProps) => {
  const [isAutoRenewChecked, setIsAutoRenewChecked] = useState(false);
  const [showExpireModal, setShowExpireModal] = useState(false);
  const [showRenewModal, setShowRenewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showNoCreditsModal, setShowNoCreditsModal] = useState(false);
  const [showCopyLinkModal, setShowCopyLinkModal] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);

  const handleAutoRenewToggle = (value: boolean) => {
    setIsAutoRenewChecked(value);
  };

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setShowExpireModal(false);
      setShowRenewModal(false);
      setShowDeleteModal(false);
      setShowCopyLinkModal(false);
    }
  };

  const handleCopy = (siteContext?: string | null, id?: number | null) => {
    // const domain_origin = window.location.origin.replace("recruiter.","www.");
    const domain_origin = siteContext ? domainMap[siteContext] : window.location.origin.replace("recruiter.","www.");
    const link = `${domain_origin}/seeker/job-details?kId=${id}`;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        // setSnackbarOpen(true);
        // setIsError(false);
        toast.success("Copied to clipboard", {
          autoClose: 5000,
          position: "bottom-left",
          toastId: "success-toast-custom",
        });
      })
      .catch(() => {
        // setSnackbarOpen(true);
        // setIsError(true);
        toast.error("Error Copying job!", {
          autoClose: 5000,
          position: "bottom-left",
        });
      });
  };

  useEffect(() => {
    let isFirstClick = true;
    const handleOutsideClick = (event: any) => {
      if (
        triggerRef.current &&
        !triggerRef.current.contains(event.target) &&
        !isFirstClick
      ) {
        setClickedRow(null);
      }
      isFirstClick = false;
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
      callbackOnClose();
    };
  }, []);

  const renewFailedCallBack = () => {
    setShowNoCreditsModal(!showNoCreditsModal);
  }

  const FolderID = selectedRowData ? selectedRowData[0]?.jobId : null;
  const ExpireDate = selectedRowData ? selectedRowData[0]?.expiredDate : null;
  const SiteContext = selectedRowData ? selectedRowData[0]?.siteContext : null;
  const dateOnly = ExpireDate ? ExpireDate.split(" ")[0] : null;

  return (
    // <div className="popover-backdrop" onClick={handleBackdropClick}>
    <div className="popover-content" ref={triggerRef}>
      <div className={isExpire ? "expire-layout disabled" : "expire-layout"} onClick={() => setShowExpireModal(true)}>
        <span className="primary-popover-text">
          Expire
        </span>
        <div className="expire-date-cont">
          {dateOnly && <ClockIcon />}
          <span className="popover-date">{dateOnly}</span>
        </div>
      </div>
      <div className="delete-popover-container" onClick={() => setShowDeleteModal(true)}>
        <p className="primary-popover-text">
          Delete
        </p>
      </div>
      {selectedRowData && selectedRowData.length > 0 && selectedRowData[0]?.jobFrom !== PASSIVE_JOB ? <div className="renew-popover-container" onClick={() => setShowRenewModal(true)}>
        <p className="primary-popover-text">
          Renew
        </p>
      </div>:null}
      {/* <div className="email-popover-container">
        <span className="primary-popover-text" style={{ cursor: "default" }}>
          Email notification
        </span>
        <Switch
          label=""
          initialValue={isAutoRenewChecked}
          onChange={handleAutoRenewToggle}
        />
      </div> */}
      <div className="share-popover-container">
        <span className="primary-popover-text" style={{ cursor: "default" }}>
          Share
        </span>
        <div className="share-icon-container">
          {/* <div
            className="ecllipse-icon"
            onClick={() => shareJob(SHARE_JOB_TYPES.LINKEDIN, FolderID)}
          >
            <EcllipseIcon />
            <div className="linkedin-icon">
              <LinkedinIcon />
            </div>
          </div> */}
          <div
            className="ecllipse-icon"
            onClick={() => shareJob(SHARE_JOB_TYPES.TWITTER, FolderID)}
          >
            <EcllipseIcon />
            <div className="linkedin-icon">
              <TwitterIcon />
            </div>
          </div>
          <div
            className="ecllipse-icon"
            onClick={() => shareJob(SHARE_JOB_TYPES.FACEBOOK, FolderID)}
          >
            <EcllipseIcon />
            <div className="linkedin-icon">
              <FacebookIcon />
            </div>
          </div>

          {/* <div style={{ cursor: "pointer" }}>
            <FounditIcon />
          </div> */}

          <div
            className="ecllipse-icon"
            onClick={() => handleCopy(SiteContext, FolderID)}
          >
            <EcllipseIcon />
            <div className="linkedin-icon">
              <LinkIcon />
            </div>
          </div>
        </div>
      </div>

      <ExpireJobsModal
        isOpen={showExpireModal}
        setIsOpen={setShowExpireModal}
        modalData={selectedRowData}
      />
      <DeleteJobsModal
        isOpen={showDeleteModal}
        setIsOpen={setShowDeleteModal}
        modalData={selectedRowData}
      />
      <RenewListModal
        isOpen={showRenewModal}
        setIsOpen={setShowRenewModal}
        modalData={selectedRowData}
        // inventoryError={renewFailedCallBack}
      />
      <CopyLinkModal
        isOpen={showCopyLinkModal}
        setIsOpen={setShowCopyLinkModal}
        id={FolderID}
      />
      <LowInventoryModal
        isOpen={showNoCreditsModal}
        setIsOpen={setShowNoCreditsModal}
        modalData={selectedRowData}
        // hitRate={}
      />
    </div>
    // </div>
  );
};

export default AdditionalContent;
